import HomeLayout from '../../../layouts/HomeLayout'

export default [
  {
    path: '/',
    component: HomeLayout
  }
]